import { BaseEntityDto } from "@/core/common/entities/base-entity.dto";
import { FileDto } from "@/core/features/file/file.dto";
import { Type } from "class-transformer";

export class UserHasQualificationHasFileDto extends BaseEntityDto {
  userHasQualificationId: string;

  @Type(() => FileDto)
  file: FileDto;

  fileId: string;
}
